import { render, staticRenderFns } from "./Impostos.vue?vue&type=template&id=a2778d64&"
import script from "./Impostos.vue?vue&type=script&lang=js&"
export * from "./Impostos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports